import { render, staticRenderFns } from "./ImageCompressor.vue?vue&type=template&id=0c14a20e&"
import script from "./ImageCompressor.vue?vue&type=script&lang=js&"
export * from "./ImageCompressor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports